import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import {
  GetAdmissionAggregateRequest,
  GetAdmissionAggregateResponse,
} from './apiTypes/endpoints/admissions';
import { ApiError } from './apiTypes/misc';
import { getAdmissionAggregatePath } from './apiTypes/paths/admissions';
import { RQUseQueryOptions } from './apiTypes/query';
import * as api from './requests';
import { removeObjectUndefinedNullValues } from './utils/removeObjectUndefinedNullValues';

const ADMISSIONS_URL = '/registration/admissions';

export function getAdmissionAggregateData(
  queryParams: GetAdmissionAggregateRequest,
): Promise<GetAdmissionAggregateResponse> {
  const params = removeObjectUndefinedNullValues(queryParams);

  return api.get(getAdmissionAggregatePath(), { params });
}

export const GET_ADMISSION_AGGREGATE_DATA_QUERY = `${ADMISSIONS_URL}/GET_ADMISSION_AGGREGATE_DATA`;

export const useGetAdmissionAggregateData = (
  initialParams: GetAdmissionAggregateRequest,
  options?: RQUseQueryOptions<GetAdmissionAggregateResponse>,
) => {
  const [params, setParams] = useState(initialParams);

  const query = useQuery<GetAdmissionAggregateResponse, ApiError>(
    [GET_ADMISSION_AGGREGATE_DATA_QUERY, params],
    () => getAdmissionAggregateData(params),
    options,
  );

  return { ...query, setParams, params };
};
